
/* ChewMax Hollow Pals picker — complete Shopify asset replacement. */
(function () {
  'use strict';

  const CHAR_IMAGES = {
    Fox: 'https://www.chewmax.co.uk/cdn/shop/files/hollow-pals-7175080.png?v=1781123381&width=120',
    Lion: 'https://www.chewmax.co.uk/cdn/shop/files/hollow-pals-8295950.png?v=1781123379&width=120',
    Cow: 'https://www.chewmax.co.uk/cdn/shop/files/hollow-pals-8901365.png?v=1781123320&width=120',
    Penguin: 'https://www.chewmax.co.uk/cdn/shop/files/hollow-pals-2709084.png?v=1781123322&width=120',
    Raccoon: 'https://www.chewmax.co.uk/cdn/shop/files/hollow-pals-3999119.png?v=1781123377&width=120',
    Skunk: 'https://www.chewmax.co.uk/cdn/shop/files/hollow-pals-1624411.png?v=1781123377&width=120',
    Squirrel: 'https://www.chewmax.co.uk/cdn/shop/files/hollow-pals-1672640.png?v=1781123381&width=120',
  };

  // Pals-only images. The original Pets images above are unchanged.
  const PALS_IMAGES = {
    Fox: 'https://cdn.shopify.com/s/files/1/1003/0989/3458/files/indestructa-pals-7578657.webp?v=1793220984',
    Frog: 'https://cdn.shopify.com/s/files/1/1003/0989/3458/files/indestructa-pals-3431790.webp?v=1793220984',
    Crocodile: 'https://cdn.shopify.com/s/files/1/1003/0989/3458/files/indestructa-pals-6565675.webp?v=1793220984',
    Rabbit: 'https://cdn.shopify.com/s/files/1/1003/0989/3458/files/indestructa-pals-8940709.webp?v=1793220984',
  };

  function isPalsProduct(selectorItem) {
    const productInfo = selectorItem.closest('product-info[data-url]');
    const url = productInfo
      ? productInfo.getAttribute('data-url')
      : window.location.pathname;

    let decoded = url || '';
    try {
      decoded = decodeURIComponent(decoded);
    } catch (error) {
      // Continue using the original URL.
    }

    return /\/products\/indestructa-pals(?:™|%E2%84%A2)?(?:[/?#]|$)/i.test(decoded);
  }

  // Keys are actual cart quantities.
  const PAID_SLOTS = { 2: 1, 4: 2, 6: 3 };

  const DISCOUNT_PILLS = {
    2: '',
    4: '+ 15% off',
    6: '+ 20% off',
  };

  const TOTAL_SAVINGS = {
    2: 'You save 50%',
    4: 'You save 57%',
    6: 'You save 60%',
  };

  const instances = new WeakMap();
  let documentObserver;

  function ensureStyles() {
    if (document.getElementById('hollow-pals-per-toy-styles')) return;

    const style = document.createElement('style');
    style.id = 'hollow-pals-per-toy-styles';

    style.textContent = [
      '.qb-tier-per-toy{display:none!important}',
      '.qb-tier-per-toy:empty{display:none}',
      '.qb-price-row--per-toy{gap:0!important;column-gap:0!important}',
      '.qb-price-row--per-toy .qb-price-main{font-size:2.55rem!important;line-height:1;font-weight:800}',
      '.qb-price-row--per-toy .qb-price-unit{margin-left:.18em!important;font-size:2.55rem!important;line-height:1;font-weight:800;color:rgb(var(--color-foreground))!important;opacity:1!important}',
      '.qb-price-row--per-toy .qb-price-compare{margin-left:.55rem!important}',
      '.qb-price-row--per-toy .qb-price-save-pill{margin-left:.65rem!important}',
      '@media screen and (max-width:749px){.qb-price-row--per-toy{display:flex!important;flex-wrap:nowrap!important;align-items:center!important;white-space:nowrap!important}.qb-price-row--per-toy .qb-price-main,.qb-price-row--per-toy .qb-price-unit{font-size:2.3rem!important}.qb-price-row--per-toy .qb-price-compare{margin-left:.35rem!important}.qb-price-row--per-toy .qb-price-save-pill{margin-left:.4rem!important;padding:.45rem .7rem!important;font-size:1rem!important}}',
      '.chewmax-atc-price{display:inline-flex;align-items:baseline;gap:.38rem;margin-left:.55rem;white-space:nowrap}',
      '.chewmax-atc-price s{opacity:.7;font-weight:400}',
      '.chewmax-atc-price strong{font-weight:800}',
    ].join('');

    document.head.appendChild(style);
  }

  function replaceWithClones(target, source) {
    target.replaceChildren();
    if (!source) return;

    Array.from(source.childNodes).forEach(function (node) {
      target.appendChild(node.cloneNode(true));
    });
  }

  function setOptionalText(element, value) {
    const text = value ? String(value).trim() : '';
    element.textContent = text;
    element.hidden = !text;
  }

  function findLabel(container, input) {
    return Array.from(container.querySelectorAll('label')).find(
      function (label) {
        return label.htmlFor === input.id;
      }
    ) || null;
  }

  function findSaveCaption(label) {
    if (!label) return null;

    return Array.from(
      label.querySelectorAll('.quantity-break__caption')
    ).find(function (caption) {
      return !caption.classList.contains('quantity-break__per-toy');
    }) || null;
  }

  function readTier(qbComponent, input, label) {
    const qty = Number.parseInt(input.value, 10);
    const paid = PAID_SLOTS[qty] || qty;
    const perToySource = label &&
      label.querySelector(
        '.chewmax-per-toy, .quantity-break__per-toy'
      );

    return {
      input: input,
      label: label,
      qty: qty,
      paid: paid,
      free: qty - paid,
      badgeSource: label &&
        label.querySelector('.quantity-break__badge'),
      priceSource: label &&
        label.querySelector('.quantity-break__price'),
      compareSource: label &&
        label.querySelector(
          '.quantity-break__compare-price:not(.hidden)'
        ),
      saveSource: findSaveCaption(label),
      perToySource: perToySource,
      compareEach: perToySource &&
        perToySource.querySelector('.chewmax-per-toy-compare')
          ? perToySource.querySelector(
              '.chewmax-per-toy-compare'
            ).textContent.trim()
          : '',
      priceEach: perToySource &&
        perToySource.querySelector('strong')
          ? perToySource.querySelector('strong').textContent.trim()
          : '',
      priceEachMinor: label &&
        label.getAttribute('data-price-each'),
      moneyFormat: qbComponent.getAttribute('data-money-format') || '',
      discount: DISCOUNT_PILLS[qty] || '',
    };
  }

  function fillPerToy(target, tier) {
    replaceWithClones(target, tier.perToySource);

    if (target.childNodes.length) {
      target.hidden = false;
      return;
    }

    const priceEachMinor = Number(tier.priceEachMinor);

    if (
      tier.priceEachMinor !== null &&
      Number.isFinite(priceEachMinor) &&
      tier.moneyFormat &&
      typeof window.formatMoney === 'function'
    ) {
      const strong = document.createElement('strong');
      strong.textContent = window.formatMoney(
        priceEachMinor,
        tier.moneyFormat,
        true
      );

      const suffix = document.createElement('span');
      suffix.textContent = 'per toy';

      target.append(strong, suffix);
      target.hidden = false;
      return;
    }

    target.hidden = true;
  }

  function makeTierButton(qbComponent, header, state, input, label) {
    const button = document.createElement('div');
    button.className = 'qb-tier-btn';
    button.setAttribute('role', 'button');
    button.tabIndex = 0;

    const badge = document.createElement('div');
    badge.className = 'qb-tier-badge';

    const buy = document.createElement('div');
    buy.className = 'qb-tier-buy';

    const offer = document.createElement('div');
    offer.className = 'qb-tier-label';

    const perToy = document.createElement('div');
    perToy.className = 'qb-tier-per-toy';

    const discount = document.createElement('div');
    discount.className = 'qb-price-save-pill';
    discount.style.display = 'inline-block';
    discount.style.marginTop = '4px';

    button.append(badge, buy, offer, perToy, discount);

    const entry = {
      input: input,
      label: label,
      button: button,
      badge: badge,
      buy: buy,
      offer: offer,
      perToy: perToy,
      discount: discount,
    };

    function chooseTier(event) {
      if (event) event.preventDefault();

      if (!input.checked) {
        input.click();
      } else {
        state.refresh(true);
      }
    }

    function onKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        chooseTier(event);
      }
    }

    function onRadioChange() {
      state.refresh(true);
    }

    button.addEventListener('click', chooseTier);
    button.addEventListener('keydown', onKeydown);
    input.addEventListener('change', onRadioChange);

    entry.destroy = function () {
      button.removeEventListener('click', chooseTier);
      button.removeEventListener('keydown', onKeydown);
      input.removeEventListener('change', onRadioChange);
    };

    header.appendChild(button);
    return entry;
  }

  function updateTierButton(qbComponent, entry) {
    const tier = readTier(
      qbComponent,
      entry.input,
      entry.label
    );

    setOptionalText(
      entry.badge,
      tier.badgeSource && tier.badgeSource.textContent
    );

    entry.buy.textContent = 'BUY ' + tier.paid;
    entry.offer.textContent = 'Get ' + tier.free + ' free';

    fillPerToy(entry.perToy, tier);

    if (tier.discount) {
      entry.discount.textContent = tier.discount;
      entry.discount.hidden = false;
      entry.discount.style.display = 'inline-block';
    } else {
      entry.discount.textContent = '';
      entry.discount.hidden = true;
      entry.discount.style.display = 'none';
    }

    entry.button.classList.toggle(
      'is-active',
      entry.input.checked
    );

    entry.button.setAttribute(
      'aria-pressed',
      entry.input.checked ? 'true' : 'false'
    );

    return tier;
  }

  function updatePriceRow(state, tier) {
    if (!tier) {
      state.priceMain.textContent = '';
      state.priceUnit.textContent = '';
      state.priceCompare.hidden = true;
      state.priceSave.hidden = true;
      return;
    }

    const isPerToy = Boolean(tier.priceEach);

    state.priceRow.classList.toggle(
      'qb-price-row--per-toy',
      isPerToy
    );

    setOptionalText(
      state.priceMain,
      isPerToy
        ? tier.priceEach
        : tier.priceSource && tier.priceSource.textContent
    );

    setOptionalText(
      state.priceUnit,
      isPerToy && tier.priceEach ? 'each' : ''
    );

    setOptionalText(
      state.priceCompare,
      isPerToy
        ? (
            tier.compareEach
              ? `${tier.compareEach} each`
              : ''
          )
        : (
            tier.compareSource &&
            tier.compareSource.textContent
          )
    );

    let saveText = TOTAL_SAVINGS[tier.qty] || '';

    if (!saveText && tier.saveSource) {
      saveText = tier.saveSource.textContent
        .trim()
        .replace(/^(you\s+)?save\s*/i, 'You save ');
    }

    setOptionalText(state.priceSave, saveText);
  }

  function updateAddToCartTotal(qbComponent, tier) {
    if (!tier || !tier.priceSource) return;

    const scope =
      qbComponent.closest('.product__info-container') ||
      qbComponent.closest('.shopify-section') ||
      document;

    const total = tier.priceSource.textContent.trim();
    const compare = tier.compareSource
      ? tier.compareSource.textContent.trim()
      : '';

    scope.querySelectorAll(
      'button.product-form__submit[name="add"]'
    ).forEach(function (button) {
      const label = button.querySelector('.main-atc__label');
      const labelText = button.querySelector(
        '.main-atc__label__text'
      );

      if (!label || !labelText) return;

      let price = label.querySelector(
        '.chewmax-atc-price'
      );

      if (!price) {
        price = document.createElement('span');
        price.className =
          'main-atc-price chewmax-atc-price';
      }

      price.replaceChildren();

      if (compare) {
        const comparePrice = document.createElement('s');
        comparePrice.textContent = compare;
        price.appendChild(comparePrice);
      }

      const totalPrice = document.createElement('strong');
      totalPrice.textContent = total;
      price.appendChild(totalPrice);

      label.replaceChildren(labelText, price);
    });
  }

  function renderPickerPanel(panel, tierLabel, totalQty) {
    panel.replaceChildren();

    if (!tierLabel) return;

    const paidCount = PAID_SLOTS[totalQty] || totalQty;
    const freeCount = totalQty - paidCount;

    const items = Array.from(
      tierLabel.querySelectorAll(
        '.quantity-break__selector-item'
      )
    );

    if (!items.length) return;

    items.forEach(function (item, index) {
      if (index === paidCount && freeCount > 0) {
        const separator = document.createElement('div');
        separator.className = 'qb-free-separator';

        const text = document.createElement('span');

        const discount = DISCOUNT_PILLS[totalQty]
          ? ' + ' +
            DISCOUNT_PILLS[totalQty]
              .replace('+ ', '')
              .toUpperCase()
          : '';

        text.textContent =
          '\u2193 YOUR ' +
          freeCount +
          ' FREE ' +
          (freeCount === 1 ? 'TOY' : 'TOYS') +
          discount +
          ' \u2193';

        separator.appendChild(text);
        panel.appendChild(separator);
      }

      const isFree = index >= paidCount;

      const rowWrap = document.createElement('div');
      rowWrap.className = 'qb-row-wrap';

      const rowLabel = document.createElement('div');
      rowLabel.className =
        'qb-row-label' + (isFree ? ' is-free' : '');

      const number = document.createElement('span');
      number.textContent = '#' + (index + 1);
      rowLabel.appendChild(number);

      if (isFree) {
        const tag = document.createElement('span');
        tag.className = 'qb-free-tag';
        tag.textContent = 'free';
        rowLabel.appendChild(tag);
      }

      rowWrap.append(rowLabel, buildGrid(item));
      panel.appendChild(rowWrap);
    });
  }

  function buildGrid(selectorItem) {
    const grid = document.createElement('div');
    grid.className = 'qb-char-grid';

    const select = selectorItem.querySelector(
      'select.quantity-break__variant-select'
    );

    if (!select) return grid;

    const images = isPalsProduct(selectorItem)
      ? PALS_IMAGES
      : CHAR_IMAGES;

    Array.from(select.options).forEach(function (option) {
      const name = option.value.trim();

      const matchedName = Object.keys(images).find(
        function (key) {
          return key.toLowerCase() === name.toLowerCase();
        }
      );

      const imageSource = matchedName &&
        images[matchedName];

      if (!imageSource) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className =
        'qb-char-btn' +
        (option.selected ? ' is-selected' : '');

      const image = document.createElement('img');
      image.src = imageSource;
      image.alt = name;
      image.loading = 'lazy';

      const label = document.createElement('span');
      label.textContent = name;

      button.append(image, label);

      button.addEventListener('click', function () {
        select.value = option.value;

        select.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        grid.querySelectorAll('.qb-char-btn').forEach(
          function (characterButton) {
            characterButton.classList.remove(
              'is-selected'
            );
          }
        );

        button.classList.add('is-selected');
      });

      grid.appendChild(button);
    });

    return grid;
  }

  function destroyComponent(qbComponent) {
    const state = instances.get(qbComponent);
    if (!state) return;

    state.destroyed = true;

    if (state.frame) {
      cancelAnimationFrame(state.frame);
    }

    state.sourceObserver.disconnect();

    state.entries.forEach(function (entry) {
      entry.destroy();
    });

    state.header.remove();
    state.priceRow.remove();
    state.pickerPanel.remove();

    qbComponent.removeAttribute('data-hp-init');
    instances.delete(qbComponent);
  }

  function buildTierHeader(qbComponent) {
    if (!(qbComponent instanceof Element)) return;

    const container = qbComponent.querySelector(
      '.quantity-breaks-container'
    );

    const inputs = container
      ? Array.from(
          container.querySelectorAll(
            'input[type="radio"][name="quantity"]'
          )
        )
      : [];

    if (!container || !inputs.length) {
      return;
    }

    const existing = instances.get(qbComponent);

    if (existing && existing.container === container) {
      return;
    }

    if (existing) {
      destroyComponent(qbComponent);
    }

    Array.from(qbComponent.children).forEach(
      function (child) {
        if (
          child.classList.contains('qb-tier-header') ||
          child.classList.contains('qb-price-row') ||
          child.classList.contains('qb-picker-panel')
        ) {
          child.remove();
        }
      }
    );

    const header = document.createElement('div');
    header.className = 'qb-tier-header';

    const priceRow = document.createElement('div');
    priceRow.className = 'qb-price-row';

    const priceMain = document.createElement('span');
    priceMain.className = 'qb-price-main';

    const priceCompare = document.createElement('span');
    priceCompare.className = 'qb-price-compare';

    const priceSave = document.createElement('span');
    priceSave.className = 'qb-price-save-pill';

    const priceUnit = document.createElement('span');
    priceUnit.className = 'qb-price-unit';

    priceRow.append(
      priceMain,
      priceUnit,
      priceCompare,
      priceSave
    );

    const pickerPanel = document.createElement('div');
    pickerPanel.className = 'qb-picker-panel';

    const state = {
      qbComponent: qbComponent,
      container: container,
      header: header,
      priceRow: priceRow,
      priceMain: priceMain,
      priceUnit: priceUnit,
      priceCompare: priceCompare,
      priceSave: priceSave,
      pickerPanel: pickerPanel,
      entries: [],
      activeInput: null,
      frame: 0,
      destroyed: false,
      sourceObserver: null,
      refresh: null,
      queueRefresh: null,
    };

    state.refresh = function (rebuildPanel) {
      if (state.destroyed || !qbComponent.isConnected) {
        return;
      }

      const currentContainer = qbComponent.querySelector(
        '.quantity-breaks-container'
      );

      const sourcesWereReplaced =
        currentContainer !== state.container ||
        state.entries.some(function (entry) {
          return (
            !entry.input.isConnected ||
            !entry.label ||
            !entry.label.isConnected
          );
        });

      if (sourcesWereReplaced) {
        destroyComponent(qbComponent);
        safeBuildTierHeader(qbComponent);
        return;
      }

      const tiers = state.entries.map(function (entry) {
        return updateTierButton(qbComponent, entry);
      });

      let activeIndex = state.entries.findIndex(
        function (entry) {
          return entry.input.checked;
        }
      );

      if (activeIndex < 0) activeIndex = 0;

      const activeEntry = state.entries[activeIndex];
      const activeTier = tiers[activeIndex];

      updatePriceRow(state, activeTier);
      updateAddToCartTotal(qbComponent, activeTier);

      if (
        rebuildPanel ||
        state.activeInput !== activeEntry.input
      ) {
        state.activeInput = activeEntry.input;

        renderPickerPanel(
          state.pickerPanel,
          activeEntry.label,
          activeTier.qty
        );
      }
    };

    state.queueRefresh = function () {
      if (state.destroyed || state.frame) return;

      state.frame = requestAnimationFrame(function () {
        state.frame = 0;
        state.refresh(false);
      });
    };

    instances.set(qbComponent, state);

    state.entries = inputs.map(function (input) {
      return makeTierButton(
        qbComponent,
        header,
        state,
        input,
        findLabel(container, input)
      );
    });

    container.parentNode.insertBefore(
      header,
      container
    );

    container.parentNode.insertBefore(
      priceRow,
      container
    );

    container.parentNode.insertBefore(
      pickerPanel,
      container
    );

    state.sourceObserver = new MutationObserver(
      state.queueRefresh
    );

    state.sourceObserver.observe(container, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'selected',
        'value'
      ],
    });

    // Only hide Shopify's native controls after a usable picker exists.
    state.refresh(true);
    const hasTierButtons = header.querySelectorAll('.qb-tier-btn').length === inputs.length;
    const hasAnimalButtons = pickerPanel.querySelector('.qb-char-btn');
    if (!hasTierButtons || !hasAnimalButtons) {
      destroyComponent(qbComponent);
      return;
    }
    qbComponent.setAttribute('data-hp-init', 'true');
  }

  function safeBuildTierHeader(qbComponent) {
    try {
      buildTierHeader(qbComponent);
    } catch (error) {
      console.error('ChewMax bundle picker could not initialize:', error);
      // The CSS fallback keeps the original Shopify controls available.
      try { destroyComponent(qbComponent); } catch (cleanupError) {
        qbComponent.removeAttribute('data-hp-init');
      }
    }
  }

  function visitQuantityBreaks(node, callback) {
    if (!(node instanceof Element)) return;

    if (node.matches('quantity-breaks')) {
      callback(node);
    }

    node.querySelectorAll(
      'quantity-breaks'
    ).forEach(callback);
  }

function init() {
  ensureStyles();

  function retryBundlePickers() {
    document.querySelectorAll(
      'quantity-breaks'
    ).forEach(safeBuildTierHeader);
  }

  retryBundlePickers();

  // Retry when mobile browsers finish loading product sections.
  window.addEventListener('load', retryBundlePickers);

  setTimeout(retryBundlePickers, 500);
  setTimeout(retryBundlePickers, 1500);
  setTimeout(retryBundlePickers, 3000);

    documentObserver = new MutationObserver(
      function (records) {
        records.forEach(function (record) {
          record.removedNodes.forEach(function (node) {
            visitQuantityBreaks(
              node,
              destroyComponent
            );
          });

          record.addedNodes.forEach(function (node) {
            visitQuantityBreaks(
              node,
              safeBuildTierHeader
            );

            if (
              node instanceof Element &&
              node.classList.contains(
                'quantity-breaks-container'
              )
            ) {
              const owner = node.closest(
                'quantity-breaks'
              );

              const state = owner &&
                instances.get(owner);

              if (
                state &&
                state.container !== node
              ) {
                destroyComponent(owner);
                safeBuildTierHeader(owner);
              }
            }
          });
        });
      }
    );

    documentObserver.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();


